<div class="conatiner-fluid">
  <div class="row" [formGroup]="parts">
    <div class="col-6 month">
      <mat-form-field>
        <mat-select formControlName="month">
          @for (month of months; track month) {
            <mat-option [value]="month">{{
            monthNames[month-1] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-6 year">
      <mat-form-field>
        <mat-select formControlName="year">
          @for (year of years; track year) {
            <mat-option [value]="year">{{
            year }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
